import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

function AddConvenioFederal() {
  const navigate = useNavigate();
  const { id } = useParams(); 

  const [form, setForm] = useState({
    objeto: "",
    objeto_completo: "",
    cp_dl_tp: "",
    contrato: "",
    numero_convenio: "",
    ano: "",
    repasse: "",
    contrapartida: "",
    valor_total: "",
    vigencia_convenio: "",
    vigencia_contrato: "",
    empresa: "",
    ois: "",
    fiscal: "",
    conta_bancaria: "",
    recurso_liberado: "",
    status: "",
  });

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/conveniosfederal/${id}`)
        .then((res) => {
          setForm(res.data);
        })
        .catch((err) => {
          console.error("Erro ao carregar convênio para editar:", err);
          alert("Erro ao carregar dados do convênio");
        });
    }
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleValueChange = (name, values) => {
    const { value } = values;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (id) {
      axios
        .put(`/api/conveniosfederal/${id}`, form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio FEDERAL atualizado com sucesso!");
            navigate("/conveniosfederal");
          } else {
            alert("Erro ao atualizar Convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    } else {
      axios
        .post("/api/conveniosfederal", form)
        .then((res) => {
          if (res.data.Status === "Success") {
            alert("Convênio FEDERAL criado com sucesso!");
            navigate("/conveniosfederal");
          } else {
            alert("Erro ao criar Convênio");
          }
        })
        .catch((err) => {
          console.error(err);
          alert("Erro no servidor");
        });
    }
  };

  return (
    <div className="px-4 py-3">
      <h3 className="mb-4">
        {id ? "Editar Convênio FEDERAL" : "Adicionar Convênio FEDERAL"}
      </h3>
      <form onSubmit={handleSubmit}>
        {/* os inputs seguem iguais */}
        <div className="mb-3">
          <label>Objeto</label>
          <input
            type="text"
            name="objeto"
            className="form-control"
            required
            value={form.objeto}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Objeto Completo</label>
          <input
            type="text"
            name="objeto_completo"
            className="form-control"
            required
            value={form.objeto_completo}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>CP/DL/TP</label>
          <input
            type="text"
            name="cp_dl_tp"
            className="form-control"
            required
            value={form.cp_dl_tp}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Contrato</label>
          <input
            type="text"
            name="contrato"
            className="form-control"
            required
            value={form.contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Número Convênio</label>
          <input
            type="text"
            name="numero_convenio"
            className="form-control"
            required
            value={form.numero_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Ano</label>
          <input
            type="text"
            name="ano"
            className="form-control"
            required
            value={form.ano}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Repasse</label>
          <NumericFormat
            name="repasse"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.repasse}
            onValueChange={(values) => handleValueChange("repasse", values)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Contrapartida</label>
          <NumericFormat
            name="contrapartida"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.contrapartida}
            onValueChange={(values) => handleValueChange("contrapartida", values)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Valor Total</label>
          <NumericFormat
            name="valor_total"
            className="form-control"
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            value={form.valor_total}
            onValueChange={(values) => handleValueChange("valor_total", values)}
            required
          />
        </div>

        <div className="mb-3">
          <label>Vigência do Convênio</label>
          <input
            type="text"
            name="vigencia_convenio"
            className="form-control"
            required
            value={form.vigencia_convenio}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Vigência do Contrato</label>
          <input
            type="text"
            name="vigencia_contrato"
            className="form-control"
            required
            value={form.vigencia_contrato}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Empresa</label>
          <input
            type="text"
            name="empresa"
            className="form-control"
            required
            value={form.empresa}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>OIS</label>
          <input
            type="text"
            name="ois"
            className="form-control"
            required
            value={form.ois}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Fiscal</label>
          <input
            type="text"
            name="fiscal"
            className="form-control"
            required
            value={form.fiscal}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Conta Bancária</label>
          <input
            type="text"
            name="conta_bancaria"
            className="form-control"
            required
            value={form.conta_bancaria}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Recurso Liberado</label>
          <input
            type="text"
            name="recurso_liberado"
            className="form-control"
            required
            value={form.recurso_liberado}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label>Status</label>
          <input
            type="text"
            name="status"
            className="form-control"
            required
            value={form.status}
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          {id ? "Atualizar Convênio" : "Salvar Convênio"}
        </button>
      </form>
    </div>
  );
}

export default AddConvenioFederal;
